/**
 * Scheme guard for URLs the agent hosts are about to hand to
 * `window.location.href` or an Android intent. The config schema already
 * restricts `WebTile.url` to http(s) (see `HttpUrl` in the core schema), but
 * the hosts also receive URLs from other paths (rich-text links, remote-config
 * swaps, future callers), so this is the defense-in-depth check at the sink:
 * a `javascript:`, `data:`, `intent:`, or `file:` URL must never reach the
 * launcher origin or a native intent.
 */
export function isHttpUrl(raw: string): boolean {
  let protocol: string;
  try {
    protocol = new URL(raw).protocol.toLowerCase();
  } catch {
    return false;
  }
  return protocol === 'http:' || protocol === 'https:';
}

/** Throw a descriptive error when [raw] isn't an http(s) URL. */
export function assertHttpUrl(raw: string): void {
  if (!isHttpUrl(raw)) {
    throw new Error(`refused non-http(s) URL: ${raw}`);
  }
}
